module.exports = __webpack_public_path__ + "static/diyanet2-e6944dfd8810eb522a40d9ff7965190b.png";